import { render, staticRenderFns } from "./CMRemindSettingPage.vue?vue&type=template&id=5306d408&"
import script from "./CMRemindSettingPage.vue?vue&type=script&lang=js&"
export * from "./CMRemindSettingPage.vue?vue&type=script&lang=js&"
import style0 from "./CMRemindSettingPage.vue?vue&type=style&index=0&id=5306d408&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5306d408')) {
      api.createRecord('5306d408', component.options)
    } else {
      api.reload('5306d408', component.options)
    }
    module.hot.accept("./CMRemindSettingPage.vue?vue&type=template&id=5306d408&", function () {
      api.rerender('5306d408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/CMRemindSettingPage.vue"
export default component.exports